<template>
  <div class="row m-0" v-if="currentUser">
    <div class="col-auto pe-0 position-relative" >
      <div class="row m-0 align-items-center" @click="toggleOpen">
        <div class="col-auto p-0">
          <ios-contact-icon />
        </div>
        <div class="col px-1 pb-1">
          {{currentUser.firstname}} {{currentUser.lastname}}
          <div class="small" v-if="currentUser.firstname && !currentUser.emailVerified">(Unverified)</div>
        </div>
        <div class="col-auto p-0 small" >
          <ios-arrow-down-icon :class="{'oneeighty_degree': isOpen}"/>
        </div>
      </div>
      <transition name="fade">
        <div class="menu_dropdown" v-if="isOpen">
          <user-menu @close="closeNav" :user="currentUser" v-if="currentUser"></user-menu>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['user'],
  components: {
    'user-menu': () => import('./UserMenu.vue')
  },
  data () {
    return {
      isOpen: false
    }
  },
  created () {
    window.addEventListener('click', this.close)
  },

  beforeDestroy () {
    window.removeEventListener('click', this.close)
  },
  computed: {
    ...mapGetters(['currentUser', 'theUser'])
  },
  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.$emit('close')
        this.isOpen = false
      }
    },
    closeNav (e) {
      this.$emit('close')
      this.isOpen = false
    },
    open () {
      this.isOpen = true
    }
  }
}
</script>

<style scoped>
  .menu_dropdown {
    position: absolute;
    top: 40px;
    right: 0;
    width: 150%;
    background-color: #fff;
    border-radius: 4px;
    -webkit-box-shadow: 0 1px 10px 1px #888;
    box-shadow: 0 1px 10px 1px #888;
    color: var(--darkblue);
  }
  .menu_dropdown:before {
    content:"\A";
    border-style: solid;
    border-width: 0 6px 10px 6px;
    border-color: transparent transparent #fff transparent;
    position: absolute;
    top: -10px;
    right: 10px;
}
  .oneeighty_degree {
    transform: rotate(180deg);
  }
</style>
